/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_SupportInputs */



/**
* | output |
* | --- |
* | "Updates & Support" |
*
* @param {Signup_Compare_Section_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_support = /** @type {((inputs?: Signup_Compare_Section_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "de") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "it") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "es") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Updates & Support")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Updates & Support")
	return /** @type {LocalizedString} */ ("Updates & Support")
});